// @flow strict

import * as React from 'react';

type ReactObjRef<ElementType: React$ElementType> = {
  current: ?React$ElementRef<ElementType>,
};

export default function useClickOnEnter<T: 'button' | 'a'>(elementRef: ?ReactObjRef<T>) {
  React.useEffect(() => {
    function handleEnterKeyUp(event) {
      if (event.key !== 'Enter' || !elementRef) return undefined;
      event.preventDefault();
      if (elementRef.current) elementRef.current.click();
      return undefined;
    }

    window.addEventListener('keyup', handleEnterKeyUp);

    return () => window.removeEventListener(handleEnterKeyUp);
  }, []);
}
